import { connect } from "react-redux";
import ValetIncentive from "./ValetIncentive";
import { bindActionCreators } from "redux";
import { valetIncentiveListing, editIncentiveList } from "services/redux/valetIncentive/action"

const mapStateToProps = (state) => ({
    incentiveListData: state.ValetIncentive.valetincentivelist,
    editIncentiveData: state.ValetIncentive.editIncentiveData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ 
    valetIncentiveListing,
    editIncentiveList
   }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ValetIncentive);
